import { Space } from "antd";
import { useSearchParams } from "react-router";
import { ProfileCard, MerchantCabinetsCard } from "@src/components";
import { useProfile, useAllMerchants } from "@src/queries";

export default function ProfilePage() {
    // const notify = useAppMessage();
    const [params] = useSearchParams();
    const initialMerchantId = params.get("merchantId") ?? undefined;
    const { data: profileData, isLoading: isProfileLoading, error: profileError } = useProfile();
    const {
        data: merchantsData,
        isPending: isMerchantsLoading,
        error: merchantsError,
    } = useAllMerchants();

    return (
        <div>
            <Space direction="vertical" size="large" className="max-w-4xl mx-auto">
                <ProfileCard data={profileData} loading={isProfileLoading} error={profileError} />
                <MerchantCabinetsCard
                    data={merchantsData}
                    loading={isMerchantsLoading}
                    error={merchantsError}
                    initialMerchantId={initialMerchantId}
                />
            </Space>
        </div>
    );
}
